import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router";
import { injectStripe } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import { getProductList, productPurchseAction } from "../../../modules/products/action";
import Loader from "../../Loader";
import FarmUtilities from "../../private/FarmUtilities/FarmUtilities";
import AddressForm from "../Checkout/AddressForm";
import PaymentForm from "../Checkout/PaymentForm";
import Review from "../Checkout/Review";
import '../../../style/main.css';

const steps = [
  "Recommended Products",
  "Shipping address",
  "Review your order",
  "Payment"
];

const requiredFields = [
  "firstName",
  "lastName",
  "town",
  "state",
  "country",
  "zipCode",
  "streetAddress",
  "contactNo"
];

const useStyles = theme => ({
  appBar: {
    position: "relative"
  },
  layout: {
    width: "auto",
    // margin: 16,
    // width: "95%"
  },
  paper: {
    marginTop: 4,
    marginBottom: 4,
    padding: 16
  },
  stepper: {
    padding: "24px 0px 40px"
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end"
  },
  button: {
    marginTop: 24,
    marginLeft: 8
  }
});

const errorHeader = "We regret to inform you that order could not be completed";
const productErrorHeader = "Unable to load recommanded items";

class Purchase extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.classes = useStyles();
    this.state = {
      planId: 1,
      planDetails: {},
      activeStep: 0,
      skippedStep: new Set([]),
      cartList: [],
      isDisabled: false,
      username: userDetail().username,
      firstName: userDetail().firstName,
      lastName: userDetail().lastName,
      town: userDetail().town,
      state: userDetail().state,
      country: userDetail().country,
      zipCode: userDetail().zipCode,
      streetAddress: userDetail().streetAddress,
      contactNo: userDetail().contactNo,
      edited: false
    };
  }

  componentDidMount = () => {
    this.props.getProductList();
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  handleChange = input => e => {
    if (!this.state.edited) this.setState({ edited: true });
    const value = e.target.value;
    if (input === "contactNo") {
      if (value.match(/^\d{0,15}?$/)) {
        this.setState({ [input]: value });
      }
    } else this.setState({ [input]: value });
  };

  getStepContent = step => {
    const {
      cartList,
      cardHolderName,
      firstName,
      lastName,
      town,
      state,
      country,
      zipCode,
      streetAddress,
      contactNo
    } = this.state;

    const values = {
      firstName,
      lastName,
      town,
      state,
      country,
      zipCode,
      streetAddress,
      cartList,
      cardHolderName,
      contactNo
    };
    switch (step) {
      case 0:
        return (
          <FarmUtilities
            handleRemoveItem={this.handleRemoveItem}
            handlePurchase={this.handlePurchase}
            cartList={values.cartList}
          />
        );
      case 1:
        return <AddressForm values={values} handleChange={this.handleChange} />;
      case 2:
        return (
          <Review
            planDetails={[]}
            products={this.props.productList.filter(item => {
              item.quantity = values.cartList.filter(
                item1 => item1 === item.productCode
              ).length;
              item.desc = item.description;
              return values.cartList.includes(item.productCode);
            })}
            values={values}
          />
        );

      case 3:
        return (
          <PaymentForm
            values={values}
            handleChange={this.handleChange}
            handleSubmit={this.submit}
            btnLabel={"Proceed to checkout"}
            isDisabled={this.state.isDisabled}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  };

  async submit(ev) {
    this.setState({
      isDisabled: true,
      edited: false
    });
    const { cartList, username, lastName, firstName, contactNo } = this.state;
    const { planId } = this.props;
    const { state, streetAddress, town, zipCode } = this.state;
    const address = { state, streetAddress, town, zipCode };
    const arrSet = new Set(cartList);
    var productList = [];
    arrSet.forEach(item => {
      var quantity = cartList.filter(item1 => item1 === item).length;
      productList.push({ productCode: item, quantity });
    });

    console.log(productList);

    let { token } = await this.props.stripe.createToken({ name: "Name" });

    if (token) {
      this.handleNext();
      const requestData = {
        address,
        firstName,
        lastName,
        planId,
        sourceToken: token.id,
        productList,
        username,
        contactNo
      };
      this.props.productPurchseAction(requestData);
      console.log(this.props.isError, this.props.error);
      console.log(requestData);
    } else {
      this.setState({
        isDisabled: false
      });
      alert("Please enter valid card information");
    }
  }

  handlePurchase = productId => {
    this.setState(
      state => {
        const cartList = [...state.cartList, productId];
        return {
          ...state,
          cartList
        };
      },
      () => {
        console.log(productId, this.state.cartList);
      }
    );
  };

  handleRemoveItem = productId => {
    this.setState(
      state => {
        const currentCart = [...state.cartList];
        const index = currentCart.indexOf(productId);
        if (index >= 0) currentCart.splice(index, 1);
        return {
          ...state,
          cartList: currentCart
        };
      },
      () => {
        console.log(productId, this.state.cartList);
      }
    );
  };

  enableNext = () => {
    let enable = true;
    if (this.state.activeStep === 1) {
      requiredFields.every(element => {
        if (!this.state[element]) {
          enable = false;
          return false;
        } else {
          if (
            (element == "firstName" || element == "lastName") &&
            this.state[element].length < 3
          ) {
            enable = false;
            return false;
          } else {
            return true;
          }
        }
      });
      return enable;
    } else {
      return enable;
    }
  };

  handleNext = () => {
    if (this.enableNext()) {
      const { activeStep, skippedStep } = this.state;
      skippedStep.delete(activeStep);
      this.setState({ activeStep: activeStep + 1, skippedStep });
    }
    document.querySelector('.navDropDownHeading').scrollIntoView();

  };

  handleBack = () => {
    const { activeStep } = this.state;
    if (activeStep === steps.length) this.setState({ isDisabled: false });
    this.setState({ activeStep: activeStep - 1 });
    document.querySelector('.navDropDownHeading').scrollIntoView();

  };

  handleGoToHomepage = () => {
    this.props.history.push("/login");
  };

  handleSkipAndSubmit = () => {
    const { planId, username, activeStep } = this.state;
    const requestData = { planId, username };
    this.setState({
      activeStep: steps.length,
      skippedStep: new Set([activeStep + 1, activeStep + 2, activeStep])
    });
    this.props.productPurchseAction(requestData);
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 2,
      skippedStep: new Set([activeStep + 1, activeStep])
    });
  };

  isStepFailed = step => {
    const { activeStep } = this.state;
    if (activeStep === 0) return step === activeStep;
    else return step === steps.length - 1;
  };

  isStepSkipped = step => {
    const { skippedStep } = this.state;
    return skippedStep.has(step);
  };

  render() {
    const {
      classes,
      isFetchingComplete,
      isError,
      planId,
      error,
      subscriptionData
    } = this.props;
    const { activeStep, cartList, edited } = this.state;
    return (
      <div>
        <Prompt when={edited} message="Changes you made may not be saved." />

      <main className={classes.layout} id="checkout">
        <Paper className={classes.paper}  id="checkout" style={{padding: '6px', width: '100%'}}>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label, index) => {
              const labelProps = {};
              const stepProps = {};
              if (isError && this.isStepFailed(index)) {
                labelProps.error = true;
              }
              if (this.isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <React.Fragment>
            {activeStep === steps.length ? (
              isFetchingComplete ? (
                !isError ? (
                  <React.Fragment>
                    <React.Fragment>
                      <Typography variant="h5" gutterBottom>
                        Thanks for your order.
                      </Typography>

                      {subscriptionData.orderId && (
                        <Typography variant="subtitle1">
                          Your order has been placed, with id{" "}
                          {subscriptionData.orderId}. We have emailed your order
                          confirmation and will send you an update when your
                          order has shipped.
                        </Typography>
                      )}
                    </React.Fragment>
                  </React.Fragment>
                ) : activeStep === 0 ? (
                  <React.Fragment>
                    <Typography variant="h5" gutterBottom>
                      {productErrorHeader}
                    </Typography>
                    <Typography variant="subtitle1">
                      {"Please refresh the page and try again again later."}
                    </Typography>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography variant="h5" gutterBottom>
                      {errorHeader}
                    </Typography>
                    <Typography variant="subtitle1">
                      {error.split(";")[0]}
                    </Typography>
                    <div className={classes.buttons}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                    </div>
                  </React.Fragment>
                )
              ) : (
                <Loader />
              )
            ) : (
              <React.Fragment>
                {this.getStepContent(activeStep)}

                <div className={classes.buttons}>
                  {activeStep !== 0 && (
                    <Button
                      onClick={this.handleBack}
                      className={classes.button}
                    >
                      Back
                    </Button>
                  )}
                  {activeStep !== steps.length - 1 && (
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={
                        (activeStep === 0 && cartList.length === 0) ||
                        !this.enableNext()
                      }
                      onClick={this.handleNext}
                      className={classes.button}
                    >
                      Next
                    </Button>
                  )}
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </Paper>
      </main>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    productList: state.productsReducer.productList,
    isError: state.productsReducer.isError,
    error: state.productsReducer.error,
    isFetchingComplete: state.productsReducer.isFetchingComplete,
    subscriptionList: state.subscriptionList.subscriptionListDetails,
    userDetails: state.subscriptionList.tokenDetails,
    subscriptionData: state.productsReducer.subscriptionData
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getProductList, productPurchseAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(injectStripe(Purchase)));



// WEBPACK FOOTER //
// ./src/components/public/Purchase/Purchase.js